import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useEffect} from "react";
import ApiService from "../../../core/service/api-service";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import autoExportRuleColumns from "./AutoExportRuleColumns";
import {useTranslation} from "react-i18next";

export default function AutoExportRuleGrid() {
    const {t} = useTranslation();
    const {setData, setPaginationResult, queryModel, setDataGridProps} = useDataGrid();

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: autoExportRuleColumns(t),
        })
    }, [])

    const getRules = async () => {
        const response = await ApiService.AutoExport.GetRules(queryModel);
        if(response.success) {
            setData(response.data);
            setPaginationResult(response.pagination)
        }
    }

    useEffect(() => {
        getRules()
    }, [queryModel.updateKey])

    return (
        <>
            <DataGrid name={'auto-export-rule'} />
        </>
    )
}
